export const isWhitespace = (value: string): boolean => value.trim().length === 0
export const isNotWhitespace = (value: string): boolean => !isWhitespace(value)
export const collapseWhitespace = (text: string): string => text.replace(/\s+/g, ' ').trim()
